// pages/Home.jsx
import React, { useState, useEffect } from 'react';
import ChatInterface from "../../components/chat/ChatInterface";
import './Home.css'; // Create this file next

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Set a small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 10);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`home-container ${isVisible ? 'fade-in' : ''}`}>
      <ChatInterface />
    </div>
  );
};

export default Home;